module.exports = __webpack_public_path__ + "img/cumbria-logo.77989454.png";